import { Dispatch, SetStateAction, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { HeaderWithBackNavigation } from '@app/components/HeaderWithBackNavigation';
import { getPlans, getRetentionOffers, selectPortfolio } from '@app/redux';
import { scrollToTop } from '@app/redux/utils';
import { OFMProductTypes } from '@app/types';

import { DisconnectPageLayout } from '../../containers';
import Content from './Content';
import { DisconnectSteps } from '../../types';

const DisconnectRetention = ({ setStep }: { setStep: Dispatch<SetStateAction<DisconnectSteps>> }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Disconnect');
  const { portfolio } = useSelector(selectPortfolio);

  const hasRetentionOffer = portfolio?.portfolioItems?.some((item) => item?.kind === OFMProductTypes.RETENTION);

  useEffect(() => {
    dispatch(getPlans());
    if (!hasRetentionOffer) {
      dispatch(getRetentionOffers());
    }
  }, []);

  const handleBackNavigation = () => setStep(DisconnectSteps.INTRO);

  const handleContinue = () => {
    setStep(DisconnectSteps.REVIEW);
    dispatch(scrollToTop());
  };

  return (
    <DisconnectPageLayout
      step={2}
      header={
        <HeaderWithBackNavigation
          title={t('page.title.retention')}
          goBackLabel={t('button.back')}
          handleBackNavigation={handleBackNavigation}
        />
      }
    >
      <Content handleContinue={handleContinue} />
    </DisconnectPageLayout>
  );
};

export default DisconnectRetention;
